import { VatDeclarationStatus } from '../enums/vatDeclarationStatus'
import { VatDeclarationSubmission } from '../types/vatDeclarationSubmission'
import { shouldUseDKReportContent } from './isSupportedCountryId'

export enum SubmitButtonVariant {
  Manual = 'manual',
  Integration = 'integration',
}

interface GetSubmitButtonLogicProps {
  countryId?: string
  correctionNo?: number
  isSkatConnected?: boolean
  submission?: VatDeclarationSubmission
  status: VatDeclarationStatus
}

interface GetSubmitButtonVariantNLProps {
  correctionNo?: number
  submission?: VatDeclarationSubmission
  status: VatDeclarationStatus
}

interface GetSubmitButtonVariantDKProps {
  correctionNo?: number
  isSkatConnected?: boolean
  status: VatDeclarationStatus
}

/* NL-specific logic: Cannot submit corrections via integration + failed submissions are not resubmitted + already submitted but voided declarations are not resubmitted */
const getSubmitButtonVariantNL = ({
  correctionNo,
  submission,
  status,
}: GetSubmitButtonVariantNLProps): SubmitButtonVariant => {
  const isCorrection = (correctionNo ?? 0) > 0
  if (isCorrection || status === VatDeclarationStatus.SubmissionFailed || !!submission) {
    return SubmitButtonVariant.Manual
  }

  return SubmitButtonVariant.Integration
}

/* DK-specific logic: Cannot submit corrections via integration */
const getSubmitButtonVariantDK = ({
  correctionNo,
  isSkatConnected,
}: GetSubmitButtonVariantDKProps): SubmitButtonVariant => {
  const isCorrection = (correctionNo ?? 0) > 0

  if (isCorrection || !isSkatConnected) {
    return SubmitButtonVariant.Manual
  }

  return SubmitButtonVariant.Integration
}

export const getSubmitButtonVariant = ({
  countryId,
  correctionNo,
  isSkatConnected,
  submission,
  status,
}: GetSubmitButtonLogicProps): SubmitButtonVariant | null => {
  /* Filter out non-submittable statuses */
  if (
    status !== VatDeclarationStatus.ReadyToSubmit &&
    status !== VatDeclarationStatus.OverdueSubmission &&
    status !== VatDeclarationStatus.SubmissionFailed
  ) {
    return null
  }

  if (countryId === 'NL') {
    return getSubmitButtonVariantNL({
      correctionNo,
      submission,
      status,
    })
  }

  if (shouldUseDKReportContent(countryId)) {
    return getSubmitButtonVariantDK({
      correctionNo,
      isSkatConnected,
      status,
    })
  }

  return null
}
